import React, { useContext } from "react";
import styled, { css } from "styled-components";
import SectionSpacingValueSpaceContext from "../../../contexts/SectionSpacingValueSpaceContext";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
var Wrapper = styled.div.withConfig({
  componentId: "sc-1vxq9m4-0"
})(function (_ref) {
  var $sectionTopSpacingValueSpace = _ref.$sectionTopSpacingValueSpace,
    $topIndentValueSpace = _ref.$topIndentValueSpace;
  return css(["margin-bottom:", ";margin-top:", ";", "{margin-top:", ";", "{margin-top:", ";margin-bottom:", ";}"], space(5), space(-1 * ($sectionTopSpacingValueSpace + $topIndentValueSpace.small || $topIndentValueSpace)), breakpoint("medium"), space(-1 * ($sectionTopSpacingValueSpace + $topIndentValueSpace.medium || $topIndentValueSpace)), breakpoint("large"), space(-1 * ($sectionTopSpacingValueSpace + $topIndentValueSpace.large || $topIndentValueSpace)), space(2));
});
function SubmitInputWrapper(_ref2) {
  var _ref2$topIndentValueS = _ref2.topIndentValueSpace,
    topIndentValueSpace = _ref2$topIndentValueS === void 0 ? 10 : _ref2$topIndentValueS,
    children = _ref2.children;
  var sectionTopSpacingValueSpace = useContext(SectionSpacingValueSpaceContext).top;
  return /*#__PURE__*/React.createElement(Wrapper, {
    $sectionTopSpacingValueSpace: sectionTopSpacingValueSpace,
    $topIndentValueSpace: topIndentValueSpace
  }, children);
}
export default SubmitInputWrapper;